import {
    GET_DASHBOARD_AUDITS,
    GET_DASHBOARD_AUDITS_SUCCESS,
    GET_DASHBOARD_AUDITS_ERROR,

    GET_DASHBOARD_ISSUES,
    GET_DASHBOARD_ISSUES_SUCCESS,
    GET_DASHBOARD_ISSUES_ERROR,

    GET_DASHBOARD_ALERTS,
    GET_DASHBOARD_ALERTS_SUCCESS,
    GET_DASHBOARD_ALERTS_ERROR,

    setDashboardAudits,
    setDashboardIssues,
    setDashboardAlerts,

    getDashboardAuditsSuccess,
    getDashboardAuditsError,

    getDashboardIssuesSuccess,
    getDashboardIssuesError,

    getDashboardAlertsSuccess,
    getDashboardAlertsError

} from "../../actions/Dashboard";

import { apiRequest } from "../../actions/api";



/* =========================================================
   AUDITS
========================================================= */

export const getDashboardAuditsFlow =
    ({ dispatch }) =>
    (next) =>
    (action) => {

        next(action);

        if (action.type === GET_DASHBOARD_AUDITS) {

            dispatch(
                apiRequest(
                    "GET",
                    "/apiCall.php?apiCall=getAuditforDash",
                    action.payload,
                    null,
                    getDashboardAuditsSuccess,
                    getDashboardAuditsError,
                    false,
                    "[Dashboard]"
                )
            );
        }
    };


export const processDashboardAudits =
    ({ dispatch }) =>
    (next) =>
    (action) => {

        next(action);

        if (action.type === GET_DASHBOARD_AUDITS_SUCCESS) {

            if (action.payload.status === true) {

                dispatch(
                    setDashboardAudits(
                        action.payload.data || []
                    )
                );
            }
        }

        if (action.type === GET_DASHBOARD_AUDITS_ERROR) {

            dispatch(
                setDashboardAudits([])
            );
        }
    };



/* =========================================================
   ISSUES
========================================================= */

export const getDashboardIssuesFlow =
    ({ dispatch }) =>
    (next) =>
    (action) => {

        next(action);

        if (action.type === GET_DASHBOARD_ISSUES) {

            dispatch(
                apiRequest(
                    "GET",
                    "/apiCall.php?apiCall=getIssueforDash",
                    action.payload,
                    null,
                    getDashboardIssuesSuccess,
                    getDashboardIssuesError,
                    false,
                    "[Dashboard]"
                )
            );
        }
    };


export const processDashboardIssues =
    ({ dispatch }) =>
    (next) =>
    (action) => {

        next(action);

        if (action.type === GET_DASHBOARD_ISSUES_SUCCESS) {

            if (action.payload.status === true) {

                dispatch(
                    setDashboardIssues(
                        action.payload.data || []
                    )
                );
            }
        }

        if (action.type === GET_DASHBOARD_ISSUES_ERROR) {

            dispatch(
                setDashboardIssues([])
            );
        }
    };



/* =========================================================
   ALERTS
========================================================= */

export const getDashboardAlertsFlow =
    ({ dispatch }) =>
    (next) =>
    (action) => {

        next(action);

        if (action.type === GET_DASHBOARD_ALERTS) {

            dispatch(
                apiRequest(
                    "GET",
                    "/apiCall.php?apiCall=getAlertforDash",
                    action.payload,
                    null,
                    getDashboardAlertsSuccess,
                    getDashboardAlertsError,
                    false,
                    "[Dashboard]"
                )
            );
        }
    };


export const processDashboardAlerts =
    ({ dispatch }) =>
    (next) =>
    (action) => {

        next(action);

        if (action.type === GET_DASHBOARD_ALERTS_SUCCESS) {

            if (action.payload.status === true) {

                dispatch(
                    setDashboardAlerts(
                        action.payload.data || []
                    )
                );
            }
        }

        if (action.type === GET_DASHBOARD_ALERTS_ERROR) {

            dispatch(
                setDashboardAlerts([])
            );
        }
    };



/* =========================================================
   DASHBOARD MIDDLEWARE
========================================================= */

export const dashboardMdl = [

    getDashboardAuditsFlow,
    processDashboardAudits,

    getDashboardIssuesFlow,
    processDashboardIssues,

    getDashboardAlertsFlow,
    processDashboardAlerts

];

